import { Facebook, Instagram, Mail } from "lucide-react";
import { SITE } from "@/data/site";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-20 md:py-40 bg-[#080808]"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-10 text-center">
        <p className="eyebrow reveal">04 — About</p>
        <h2 className="font-display text-white font-light text-4xl md:text-6xl tracking-tighter mt-5 leading-[1.05] reveal">
          Meet <span className="gold-text italic mr-3 md:mr-5">Warren</span> &amp; the
          studio.
        </h2>
        <p className="font-serif italic text-white/70 text-xl md:text-2xl leading-relaxed mt-10 max-w-3xl mx-auto reveal">
          “Passion is our driving force, motivating us in our relentless
          pursuit of the finest methods, products and tools. We aspire to be
          at the forefront of car care — establishing new standards in
          detailing.”
        </p>

        <div className="flex items-center justify-center gap-3 mt-10 reveal">
          <div className="w-10 h-px bg-[#D4AF37]" />
          <p className="text-xs uppercase tracking-[0.35em] text-[#D4AF37]">
            Warren Edgecombe · Owner
          </p>
          <div className="w-10 h-px bg-[#D4AF37]" />
        </div>

        <div className="mt-14 flex items-center justify-center gap-5 reveal">
          <a
            href={SITE.socials.facebook}
            target="_blank"
            rel="noreferrer"
            data-testid="about-social-facebook"
            aria-label="Facebook"
            className="w-12 h-12 border border-white/10 flex items-center justify-center text-white/70 hover:text-[#D4AF37] hover:border-[#D4AF37] transition"
          >
            <Facebook className="w-5 h-5" />
          </a>
          <a
            href={SITE.socials.instagram}
            target="_blank"
            rel="noreferrer"
            data-testid="about-social-instagram"
            aria-label="Instagram"
            className="w-12 h-12 border border-white/10 flex items-center justify-center text-white/70 hover:text-[#D4AF37] hover:border-[#D4AF37] transition"
          >
            <Instagram className="w-5 h-5" />
          </a>
          <a
            href={`mailto:${SITE.email}`}
            data-testid="about-social-email"
            aria-label="Email"
            className="w-12 h-12 border border-white/10 flex items-center justify-center text-white/70 hover:text-[#D4AF37] hover:border-[#D4AF37] transition"
          >
            <Mail className="w-5 h-5" />
          </a>
        </div>
      </div>
    </section>
  );
}
